import { PREVIEW_TEMP_PDF_EINVOICE } from "@/api/endpoint-defines/e-invoice-management";

export const SiteActionsCode = {
  ADD: 'SI001',
  EDIT: 'SI002',
  DEACTIVE: 'SI003',
  SEE_ALL_SITE: 'SI004',
};

export const UserActionsCode = {
  ADD: 'US001',
  EDIT: 'US002',
  DELETE: 'US003',
  CHANGE_ROLE: 'US004',
};

export const RoleActionsCode = {
  EDIT: 'RM002',
};

export const InvoiceActionsCode = {
  VIEW_PDF: 'EV009',
};

export const SymbolActionsCode = {
  ADD: 'IS001',
  EDIT: 'IS002',
  DELETE: 'IS003',
};

export const PageCodes = {
  UserManagement: 'US000',
  RoleManagement: 'RM000',
};

export const EInvoiceActionCodes = {
  ADD: 'EV001',
  VIEW: 'EV002',
  EDIT: 'EV003',
  CANCEL: 'EV004',
  RELEASE: 'EV005',
  SIGN: 'EV006',
  ADJUST: 'EV007',
  REPLACE: 'EV008',
  VIEW_PDF: 'EV009',
  ADD_FILTER: 'EV010',
  DELETE: 'EV012',
  DRAFT : 'EV013',
  PREVIEW : 'EV44',
  PREVIEW_TEMP_PDF : 'EV053',
}

export const EInvoiceConfigurationCode = {
  EDIT: 'EV014'
}